import Vue from "vue";
import VueRouter from "vue-router";

import dashboard from "./pages/dashboard/dashboard.vue";

import anagrafiche from "./pages/anagrafiche/index.vue";

import settings from "./pages/settings/index.vue";
import settingsAlert from "./pages/settings/alert/index.vue";
import settingsAlertDetail from "./pages/settings/alert/alertDetail.vue";

import notificationsettings from "./pages/notification/index.vue";

import alarms from "./pages/alarms/index.vue";

import mezzi from "./pages/mezzi/index.vue";
import mezziDetailVue from "./pages/mezzi/mezziDetail.vue";

import geolocation from "./pages/geolocation/index.vue";

import brands from "./pages/brands/index.vue";

import drivers from "./pages/drivers/index.vue";
import driverDetailVue from "./pages/drivers/driverDetail.vue";
import geofences from "./pages/geofence/index.vue";
import geofenceDetailVue from "./pages/geofence/geofenceDetail.vue";

import categories from "./pages/categories/index.vue";

import trips from "./pages/trips/index.vue";
import diagnostic from "./pages/trips/diagnostic/index.vue";
import planner from "./pages/trips/planner/index.vue";
import poi from "./pages/trips/poi/index.vue";

import login from "./pages/login.vue";

import report from "./pages/report/index.vue";
import tripsReport from "./pages/report/report-items/trips/trips-report.vue";
import utilizationReport from "./pages/report/report-items/timings/timings.vue";
import journeyReport from "./pages/report/report-items/journey/journey-report.vue";
import behaviorsReport from "./pages/report/report-items/behaviors/behaviors-report.vue";
import diagnosticReport from "./pages/report/report-items/diagnostic/diagnostic-report.vue";
import alarmsReport from "./pages/report/report-items/alarms/alarms-report.vue";
import tripEventsReport from "./pages/report/report-items/trip-events/trip-events-report.vue";
import lastDiagnosticReport from "./pages/report/report-items/last-diagnostic/last-diagnostic-report.vue";

import test from "./pages/test/index.vue";

Vue.use(VueRouter);

export const routes = [
	{
		path: "/login",
		name: "login",
		component: login,
		props: true,
		meta: {
			requiresAuth: false,
			layout: "no-sidebar"
		}
	},
	{
		path: "/",
		name: "dashboard",
		component: dashboard,
		meta: {
			requiresAuth: true
		}
	},
	// {
	// 	path: "/test",
	// 	name: "test",
	// 	component: test,
	// 	meta: {
	// 		requiresAuth: true
	// 	}
	// },
	{
		path: "/settings",
		name: "PREFERENCES_SETTINGS_BOX",
		component: settings,
		meta: {
			requiresAuth: true,
			permission: "PREFERENCES_SETTINGS_BOX"
		}
	},
	{
		path: "/settings/alerts",
		name: "PREFERENCES_ALERT_BOX",
		component: settingsAlert,
		meta: {
			requiresAuth: true,
			permission: "PREFERENCES_ALERT_BOX"
		}
	},
	{
		path: "/settings/alerts/:id",
		name: "PREFERENCES_DETAIL_ALERT_BOX",
		component: settingsAlertDetail,
		meta: {
			requiresAuth: true,
			permission: "PREFERENCES_ALERT_BOX"
		}
	},
	{
		path: "/supporttables",
		name: "PREFERENCES_SUPPORT_TABLES_BOX",
		component: anagrafiche,
		meta: {
			requiresAuth: true,
			permission: "PREFERENCES_SUPPORT_TABLES_BOX"
		}
	},
	{
		path: "/vehicles",
		name: "VEHICLES_LIST_BOX",
		component: mezzi,
		meta: {
			requiresAuth: true,
			permission: "VEHICLES_LIST_BOX"
		}
	},
	{
		path: "/vehicles/:id",
		name: "VEHICLE_DETAIL",
		component: mezziDetailVue,
		meta: {
			requiresAuth: true,
			permission: "VEHICLES_LIST_BOX"
		}
	},
	{
		path: "/drivers",
		name: "DRIVERS_LIST_BOX",
		component: drivers,
		meta: {
			requiresAuth: true,
			permission: "DRIVERS_LIST_BOX"
		}
	},
	{
		path: "/drivers/:id",
		name: "DRIVERS_DETAIL",
		component: driverDetailVue,
		meta: {
			requiresAuth: true,
			permission: "DRIVERS_LIST_BOX"
		}
	},
	{
		path: "/geofences",
		name: "GEOFENCES",
		component: geofences,
		meta: {
			requiresAuth: true,
			permission: "GEOFENCES"
		}
	},
	// {
	// 	path: "/geofences",
	// 	name: "GEOFENCES_LIST_BOX",
	// 	component: geofences,
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: "GEOFENCES_LIST_BOX"
	// 	}
	// },
	{
		path: "/geofence/:id",
		name: "GEOFENCE_DETAIL",
		component: geofenceDetailVue,
		meta: {
			requiresAuth: true,
			permission: "GEOFENCES"
		}
	},
	{
		path: "/alarms",
		name: "ALARMS",
		component: alarms,
		meta: {
			requiresAuth: true,
			permission: "ALARMS"
		}
	},
	{
		path: "/geolocation",
		name: "GEOLOCATION",
		component: geolocation,
		meta: {
			requiresAuth: true,
			permission: "GEOLOCATION"
		}
	},
	{
		path: "/trips",
		name: "TRIPS_DATA",
		component: trips,
		meta: {
			requiresAuth: true,
			permission: "TRIPS_DATA"
		}
	},
	{
		path: "/trips/diagnostic",
		name: "TRIPS_DIAGNOSTIC_DATA",
		component: diagnostic,
		meta: {
			requiresAuth: true,
			permission: "TRIPS_DIAGNOSTIC_DATA"
		}
	},
	{
		path: "/trips/planner",
		name: "TRIPS_ROUTES",
		component: planner,
		meta: {
			requiresAuth: true,
			permission: "TRIPS_ROUTES"
		}
	},
	{
		path: "/trips/poi",
		name: "TRIPS_POI",
		component: poi,
		meta: {
			requiresAuth: true,
			permission: "TRIPS_POI"
		}
	},
	// {
	// 	path: "/brands",
	// 	name: "brands",
	// 	component: brands,
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: "brands"
	// 	}
	// },
	// {
	// 	path: "/categories",
	// 	name: "categories",
	// 	component: categories,
	// 	meta: {
	// 		requiresAuth: true
	// 	}
	// },
	{
		path: "/report",
		name: "REPORT",
		component: report,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/trips",
		name: "REPORT_TRIPS",
		component: tripsReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/utilization",
		name: "REPORT_UTILIZATION",
		component: utilizationReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/journey",
		name: "REPORT_JOURNEY",
		component: journeyReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/behaviors",
		name: "REPORT_BEHAVIORS",
		component: behaviorsReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/alarms",
		name: "REPORT_ALARMS",
		component: alarmsReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/diagnostic",
		name: "REPORT_DIAGNOSTIC",
		component: diagnosticReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/tripevents",
		name: "REPORT_TRIP_EVENTS",
		component: tripEventsReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	},
	{
		path: "/report/lastdiagnostic",
		name: "REPORT_LAST_DIAGNOSTIC",
		component: lastDiagnosticReport,
		meta: {
			requiresAuth: true,
			permission: "MYREPORTS_MENU_BOX"
		}
	}
];

const router = new VueRouter({
	mode: "history",
	routes: routes
});

export default router;
